<script setup>
const props = defineProps({
  model: Object,
  data: Object,
  searchTerm: String,
})

const emit = defineEmits(['update:searchTerm', 'removeFilter', 'addFilter', 'clearSearch'])
const appConfig = useAppConfig()
const localSearchTerm = ref(props.searchTerm)
const searchInputId = useId()

watch(() => props.searchTerm, (val) => {
  if (val !== localSearchTerm.value)
    localSearchTerm.value = val
})

watch(localSearchTerm, (val) => {
  emit('update:searchTerm', val)
})

function clearSearch() {
  localSearchTerm.value = ''
}

function removeFilter(category, optionName) {
  emit('removeFilter', category, optionName)
}

function addFilter(category, optionName) {
  emit('addFilter', category, optionName)
}
</script>

<template>
  <div>
    <!-- Filter categories -->
    <div class="border-b-2 border-med-light-aqua">
      <ProductSearchCategoryBlock
        v-for="category in model.searchCategories?.expandedValue?.filter(x => x.categoryCvlIdentifier.value)"
        :key="category.categoryCvlIdentifier.value"
        :model="category"
        :search="data?.availableFilters?.find(e => e.categoryCvlIdentifier === category.categoryCvlIdentifier?.value)"
        :filter="data?.filter?.find(e => e.categoryCvlIdentifier === category.categoryCvlIdentifier?.value)"
        @remove-filter="removeFilter"
        @add-filter="addFilter"
      />
    </div>

    <!-- Search input -->
    <div class="prose my-8">
      <label
        class="text-med-navy"
        :for="searchInputId"
      >
        {{ model.productSearchTextboxTitle.value }}
      </label>
      <div class="relative mt-2">
        <UInput
          :id="searchInputId"
          v-model="localSearchTerm"
          type="search"
          class="boder-med-deep-navy rounded-xl w-full"
          :trailing-icon="localSearchTerm?.length > 0 ? '' : appConfig.ui.icons.search"
          :ui="{ trailing: 'pe-1' }"
        >
          <template
            v-if="localSearchTerm?.length"
            #trailing
          >
            <UButton
              variant="ghost"
              size="sm"
              :icon="appConfig.ui.icons.close"
              aria-label="Clear input"
              @click="clearSearch"
            />
          </template>
        </UInput>
      </div>
    </div>
  </div>
</template>
